import React, { Fragment, useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { H6, P, Btn } from "../../../../AbstractElements";
import { Copyhighlighte, CopyPortionParagraph, Loremipsum, Loremipsum2 } from "../../../../Constant";
import HeaderCard from "../../../Common/HeaderCard";
const ClipboardHighlight = () => {
  const [highlightTextValue, setHighlightTextValue] = useState("dolor sit amet");

  const handleCopy = async () => {
    await navigator.clipboard.writeText(highlightTextValue);
    setHighlightTextValue(highlightTextValue);
  };
  return (
    <Fragment>
      <Col sm="12" md="6">
        <Card>
          <HeaderCard title={CopyPortionParagraph} />
          <CardBody>
            <div className="clipboaard-container">
              <P className="card-description">{CopyPortionParagraph}</P>
              <H6 className="border rounded card-body f-w-300">
                {Loremipsum} <span className="bg-primary text-white p-1">{"dolor sit amet"}</span>
                {Loremipsum2}
              </H6>
              <div className="mt-3 text-end">
                <Btn color="primary btn-clipboard" onClick={handleCopy}>
                  <i className="fa fa-copy"></i> {Copyhighlighte}
                </Btn>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </Fragment>
  );
};
export default ClipboardHighlight;
